import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  ValidatedWhitelabelConfig,
  WhitelabelConfigState
} from './whitelabel-config.model';

const INITIAL_STATE: WhitelabelConfigState = {
  status: 'loading',
  config: null,
  error: null
};

@Injectable({ providedIn: 'root' })
export class WhitelabelConfigStore {
  private readonly stateSubject = new BehaviorSubject<WhitelabelConfigState>(INITIAL_STATE);
  readonly state$ = this.stateSubject.asObservable();

  get snapshot(): WhitelabelConfigState {
    return this.stateSubject.value;
  }

  getConfig<T>(path: string, fallback: T): T {
    const value = path
      .split('.')
      .filter(Boolean)
      .reduce<unknown>((current, key) => {
        if (!current || typeof current !== 'object') {
          return undefined;
        }
        return (current as Record<string, unknown>)[key];
      }, this.snapshot.config);

    return value === undefined || value === null ? fallback : value as T;
  }

  setReady(config: ValidatedWhitelabelConfig): void {
    this.stateSubject.next({ status: 'ready', config, error: null });
  }

  setError(message: string): void {
    this.stateSubject.next({ status: 'error', config: null, error: message });
  }
}
